import { connect } from 'react-redux';
import { createToolbarEvent } from '../../../analytics/AnalyticsEvents';
import { sendAnalytics } from '../../../analytics/functions';
import { translate } from '../../../base/i18n/functions';
import { IconScreenshare, IconToggledScreenshare } from '../../../base/icons/svg';
import JitsiMeetJS from '../../../base/lib-jitsi-meet/_';
import AbstractButton from '../../../base/toolbox/components/AbstractButton';
import { startScreenShareFlow } from '../../../screen-share/actions.web';
import { isScreenVideoShared } from '../../../screen-share/functions';
import { closeOverflowMenuIfOpen } from '../../actions.web';
import { isDesktopShareButtonDisabled } from '../../functions.web';
import { SCREENSHARE_STARTED } from '../../actionTypes';
/**
 * Implementation of a button for sharing desktop / windows.
 */
class ShareDesktopButton extends AbstractButton {
    constructor(props) {
        super(props);
        this.accessibilityLabel = 'toolbar.accessibilityLabel.shareYourScreen';
        this.toggledAccessibilityLabel = 'toolbar.accessibilityLabel.stopScreenSharing';
        this.label = 'toolbar.startScreenSharing';
        this.icon = IconScreenshare;
        this.toggledIcon = IconToggledScreenshare;
        this.toggledLabel = 'toolbar.stopScreenSharing';
    }
    /**
     * Retrieves tooltip dynamically.
     *
     * @returns {string}
     */
    _getTooltip() {
        const { _desktopSharingEnabled, _screensharing } = this.props;
        if (_desktopSharingEnabled) {
            if (_screensharing) {
                return 'toolbar.stopScreenSharing';
            }
            return 'toolbar.startScreenSharing';
        }
        return 'dialog.shareYourScreenDisabled';
    }
    /**
     * Indicates whether this button is in toggled state or not.
     *
     * @override
     * @protected
     * @returns {boolean}
     */
    _isToggled() {
        return this.props._screensharing || this.props.screenShareStarted;
    }
    /**
     * Indicates whether this button is in disabled state or not.
     *
     * @override
     * @protected
     * @returns {boolean}
     */
    _isDisabled() {
        return !this.props._desktopSharingEnabled;
    }
    /**
     * Handles clicking the button, and toggles the chat.
     *
     * @private
     * @returns {void}
     */
    _handleClick() {
        console.log('click');
        const { dispatch, _screensharing, screenShareStarted } = this.props;
        sendAnalytics(createToolbarEvent('toggle.screen.sharing', { enable: !_screensharing }));
        dispatch(closeOverflowMenuIfOpen());
        dispatch(startScreenShareFlow(!_screensharing));
        dispatch({
            screenShareStarted: !screenShareStarted,
            type: SCREENSHARE_STARTED
        });
    }
}
/**
 * Function that maps parts of Redux state tree into component props.
*
 * @param {Object} state - Redux state.
 * @returns {Object}
 */
const mapStateToProps = (state) => {
    // Disable the screen-share button if the video sender limit is reached and there is no video or media share in
    // progress.
    const desktopSharingEnabled = JitsiMeetJS.isDesktopSharingEnabled() && !isDesktopShareButtonDisabled(state);
    return {
        screenShareStarted: state['features/toolbox'].screenShareStarted,
        _desktopSharingEnabled: desktopSharingEnabled,
        _screensharing: isScreenVideoShared(state),
        visible: JitsiMeetJS.isDesktopSharingEnabled()
    };
};
export default translate(connect(mapStateToProps)(ShareDesktopButton));
